import React, { FC, useState, useEffect } from "react"
import labelImage from "../../../static/images/label.png"
import axios from "axios"
import { Button } from "ui-kit-sber/dist/js/components/Button"
import { Input } from "ui-kit-sber/dist/js/components/Input"
import { Modal } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import "./style.sass"
import styled from "styled-components"

let baseUrl = ""

if (process.env.NODE_ENV === "development") {
  baseUrl = "https://npfsb.crtweb.ru"
} else if (process.env.NODE_ENV === "production") {
  baseUrl = "https://npfsberbanka.ru"
}

interface InputProps {
  className?: string
  id?: string
}

const SInput = styled(Input)`
  height: inherit !important;
`

const InputComponent: FC<InputProps> = props => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [email, setEmail] = useState<string>("")
  const [validationError, setValidationError] = useState<string>("")
  const [touched, setTouched] = useState<boolean>(false)

  const closeModalOnEnterPress = event => {
    if (event.keyCode === 13 || event.keyCode === 27) {
      setShowModal(false)
    }
  }

  useEffect(() => {
    if (showModal) {
      window.addEventListener("keypress", closeModalOnEnterPress)
    } else {
      window.removeEventListener("keypress", closeModalOnEnterPress)
    }
  }, [showModal])

  const toggleModal = () => {
    setShowModal(isVisible => !isVisible)
  }

  const handleSubmit = () => {
    let localError = ""

    if (!touched) {
      localError = validateEmail(email)
      setTouched(true)
    }

    if (!localError && !validationError) {
      // send request
      axios
        .post(
          `https://npfsberbanka.ru/api/kpp/subscribe/`,
          { email },
        )
        .then(() => {
          toggleModal()
        })
        .catch(error => {
          console.log(error)
        })
    }
  }

  const delegateHandleSubmit = event => {
    if (event.keyCode === 13) {
      handleSubmit()
    }
  }

  const validateEmail = (value): string => {
    const regexp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    let validationError = ""

    if (!value.match(regexp)) {
      validationError = "Введите корректный E-mail"
    } else {
      validationError = ""
    }

    setValidationError(validationError)

    return validationError
  }

  const handleValidateEmail = event => {
    const {
      target: { value },
    } = event

    if (touched) {
      validateEmail(value)
    }

    setEmail(value)
  }

  return (
    <div {...props}>
      <SInput
        placeholder="Введите E-mail"
        type="email"
        value={email}
        onChange={handleValidateEmail}
        onKeyUp={delegateHandleSubmit}
      />
      <span className={validationError ? "" : "hidden"}>{validationError}</span>
      <Button
        onClick={handleSubmit}
        style={{ position: "relative", zIndex: 1 }}
      >
        Подписаться
      </Button>
      <Modal
        show={showModal}
        onHide={toggleModal}
        centered
        contentClassName="sber-modal"
      >
        <Modal.Body bsPrefix="sber-modal__body">
          <img src={labelImage} alt="ok-sign" />
          <h2 className="sber-modal__body-title">Вы подписаны</h2>
          <p className="sber-modal__body-text">{`Как только личный кабинет для юридических лиц начнет свою работу - мы уведомим Вас письмом на адрес ${email}`}</p>
          <Button onClick={toggleModal} className="sber-modal__body-button">
            Отлично
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default InputComponent
